module.exports = __webpack_public_path__ + "img/home_type_automatic.f0634be5.webp";